
import seo from '~/mixins/seo'
import pwaControl from '~/mixins/pwaControl'

export default {
  mixins: [pwaControl],
  head () {
    const localizedHead = seo.head.call(this)
    return {
      ...localizedHead,
      title: this.$t('title.login_layout'),
      meta: [
        ...localizedHead.meta,
        {
          hid: 'description',
          name: 'description',
          content: this.$t('meta.login_layout')
        }
      ],
      link: [
        ...localizedHead.link,
        {
          rel: 'preconnect',
          href: 'https://fonts.googleapis.com'
        },
        {
          rel: 'preconnect',
          href: 'https://fonts.gstatic.com'
        },
        {
          rel: 'stylesheet',
          href: 'https://fonts.googleapis.com/css2?family=Nunito&display=swap'
        },
        {
          rel: 'stylesheet',
          href: 'https://fonts.googleapis.com/css2?family=Nunito:wght@300;500;600;700&display=swap'
        },
      ]
    }
  },
}

